import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const stats = [{
  value: '+100',
  label: 'Case control tools'
}, {
  value: '6',
  label: 'Command center volumes'
}, {
  value: '30+',
  label: 'Workflow templates'
}, {
  value: '15 min',
  label: 'Target case organization time'
}];
const proofPoints = ['Instant download', 'No subscription', 'Lifetime access', '7-day guarantee'];
export function Hero() {
  return <header className="w-full bg-navy-950 text-white" data-id="element-172" data-mp="mrxze6fs5ypw">
      <div className="mx-auto max-w-6xl px-4 pb-10 pt-8 sm:px-6 md:pb-16 md:pt-12" data-id="element-173" data-mp="quualc2zqsjt">
        <div className="flex flex-col items-center gap-2 text-center" data-id="element-174" data-mp="vlu8ajjxpend">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.42em] text-brand-400" data-id="element-175" data-mp="vootweeop5id">
            Dr. Karito
          </p>
          <div className="h-px w-16 bg-white/20" data-id="element-176" data-mp="15lbed233lujv" />
        </div>

        <div className="mt-8 grid items-center gap-10 md:mt-12 md:grid-cols-[1.05fr_1fr] md:gap-12" data-id="element-177" data-mp="1ajmmn8dqvwzz">
          <div className="text-center md:text-left" data-id="element-178" data-mp="9nt0bz3p0lhw">
            <h1 className="font-display text-[30px] font-black uppercase leading-[1.05] tracking-tight sm:text-5xl md:text-[52px]" data-id="element-179" data-mp="9pdvnqxu08gt">
              Aligner Case
              <span className="mt-1 block text-brand-400" data-id="element-180" data-mp="3vuhfyyiq0zpc">Commander™</span>
            </h1>

            <p className="mx-auto mt-5 max-w-xl font-display text-[19px] font-bold leading-snug text-white sm:text-2xl md:mx-0" data-id="element-181" data-mp="3rtp7w8ll50un">
              Organize Any Aligner Case in 15 Minutes
            </p>
            <p className="mx-auto mt-3 max-w-xl text-[14px] leading-relaxed text-brand-100/80 sm:text-base md:mx-0" data-id="element-182" data-mp="nfhd84lrndzx">
              Without jumping between PDFs, courses, notes, and scattered resources. Turn a scattered
              aligner workflow into one visual case command center — organize what you need to review,
              track, document, and follow at every stage of the case.
            </p>

            <div className="mx-auto mt-6 flex max-w-xl flex-wrap justify-center gap-x-4 gap-y-2 md:mx-0 md:justify-start" data-id="element-183" data-mp="16djsvssfbyl2">
              {proofPoints.map(point => <span key={point} className="flex items-center gap-1.5 text-[12px] font-semibold text-brand-100/90 sm:text-[13px]" data-id="element-184" data-mp="30o9vyo8s0naa">
                  <CheckIcon className="h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-185" data-mp="2qu1ecvlaaeqw" />
                  {point}
                </span>)}
            </div>
          </div>

          <figure className="mx-auto w-full max-w-lg" data-id="element-186" data-mp="2hu4m6jzoqxr3">
            <img src="https://cdn.magicpatterns.com/uploads/gBewErZGfbdAWy8fxc9sE7/CASE-EN.png" alt="Aligner Case Commander — 6-volume visual case organization system shown as printed volumes, dashboards and quick command cards" className="w-full" width={1080} height={1080} data-id="element-187" data-mp="2musmjw9t0qxz" />
            <figcaption className="mt-2 text-center text-[11px] font-semibold uppercase tracking-wide text-brand-100/60" data-id="element-188" data-mp="642b2zf6otum">
              6-volume visual case organization system
            </figcaption>
          </figure>
        </div>

        <div id="first-cta" className="mx-auto mt-8 max-w-xl" data-id="element-189" data-mp="1qofq3soij78y">
          <CTAButton subtext="Instant download · No subscription · Lifetime access · 7-day guarantee" onDark data-id="element-190" data-mp="1qm30ctcijslc" />
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4 md:gap-4" data-id="element-191" data-mp="20lbsdgntix52">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl bg-white/[0.07] px-3 py-4 text-center ring-1 ring-white/10" data-id="element-192" data-mp="2ebp29ok9slx1">
              <dt className="sr-only" data-id="element-193" data-mp="2obxxaz2j01au">{stat.label}</dt>
              <dd data-id="element-194" data-mp="2o9bs3633xxvs">
                <span className="block font-display text-2xl font-black uppercase text-brand-400 sm:text-3xl" data-id="element-195" data-mp="2jcuuzmdxk96k">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase leading-tight tracking-[0.12em] text-brand-100/70 sm:text-[11px]" data-id="element-196" data-mp="tzrcd8jty65c">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}